var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_c('div',{staticClass:"headers"},[_c('div',[_c('Input',{staticStyle:{"min-width":"80px","width":"150px","margin-left":"20px"},attrs:{"placeholder":"商品ID,逗号分隔","clearable":""},model:{value:(_vm.filterIds),callback:function ($$v) {_vm.filterIds=$$v},expression:"filterIds"}}),_c('Button',{staticStyle:{"margin-right":"10px"},on:{"click":_vm.getRecords}},[_vm._v("搜索")]),_c('Button',{on:{"click":_vm.getRecords}},[_vm._v("刷新")])],1)]),_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data},scopedSlots:_vm._u([{key:"id",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.id))])]}},{key:"url",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Poptip',{attrs:{"trigger":"hover","transfer":true,"title":"图片详情"}},[_c('div',{staticClass:"info-pop",attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":row.url}})]),_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":row.url}})])]}},{key:"priority",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.priority))])]}},{key:"category_id",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("getClassify")(row.category_id)))])]}},{key:"jewel_price",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.jewel_price))])]}},{key:"coin_price",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.coin_price))])]}},{key:"discount",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("getDiscount")(row.discount)))])]}},{key:"status",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("getStatus")(row.status)))])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('div',[_c('Button',{on:{"click":function($event){return _vm.handleToTop(row, index)}}},[_vm._v("置顶")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }